module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Animate component is a Wrapper which gives different animation styles to its children.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<p>A secondary button:</p>\n<pre><code>&lt;Animate transitionEnterTimeout={300} transitionLeaveTimeout={300} animation=&quot;zoom&quot;&gt;\n    &lt;Logo/&gt;\n&lt;/Animate&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Animate/README.md
// module id = 333
// module chunks = 0